import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const List= () => import( './components/Transaction/List.vue')
const allList= () => import( './components/Transaction/allList.vue')
const Login = () => import( './components/Login.vue')
const Home = () => import('./components/Home.vue')
const Welcome = () => import('./components/welcome.vue')
const Message = () => import('./components/message.vue')
const Detail = () => import('./components/Goods/detail.vue')
const Query = () => import('./components/Goods/query.vue')
const userQuery=()=>import('./components/Users/userquery.vue')
const userEdit=()=>import('./components/Users/userEdit.vue')
const userAdd=()=>import('./components/Users/userAdd.vue')
const psd=()=>import('./components/Users/psd_edit.vue')
const head=()=>import('./components/Head/head_list.vue')
const head_detail=()=>import('./components/Head/head_detail.vue')
const staff_detail=()=>import('./components/Staff/staff_detail.vue')
const staff_list=()=>import('./components/Staff/staff_list.vue')
const all_staff_list=()=>import('./components/Staff/all_staff_list.vue')
const staff_department=()=>import('./components/Staff/staff_department.vue')
const department_detail=()=>import('./components/Department/detail.vue')
const task_list=()=>import('./components/Task/list.vue')
const re_task_list=()=>import('./components/Task/re_list.vue')
const task_detail=()=>import('./components/Task/staff_list.vue')
const bill=()=>import('./components/Bill/bill.vue')



const routes = [
    { path: '/', redirect: '/login' },
    { path: '/login', component: Login },
    { path: '/home',
        component: Home,
        children: [
            { path: '/message', component: Message },
            { path: '/welcome', component: Welcome },
            { path: '/lists', component: List },
            { path: '/alllists', component:allList},
            { path: '/detail/:id/',name: "detail", component: Detail},
            { path: '/userquery', component: userQuery},
            { path: '/query/:id/' ,name: "query",component: Query },
            { path: '/user-edit', component: userEdit },
            { path: '/psd-edit', component: psd },
            { path: '/user-add', component: userAdd },
            { path: '/head-list', component: head },
            { path: '/staff-list', component: staff_list },
            { path: '/all-staff-list', component: all_staff_list },
            { path: '/staff-department', component: staff_department},
            { path: '/head-detail/:id/',name: "head-detail", component: head_detail},
            { path: '/staff-detail/:id/',name: "staff-detail", component: staff_detail},
            { path: '/department-detail/:id/',name: "department-detail", component: department_detail},
            { path: '/task-detail/:id/:identity',name: "task-detail", component: task_detail},
            { path: '/task-list', component:task_list},
            { path: '/re-task-list', component:re_task_list},
            { path: '/bill/:id/',name: "bill",component:bill}
        ]
    },

]

const router = new Router({
    routes
})

// // 挂载路由导航守卫,to表示将要访问的路径，from表示从哪里来，next是下一个要做的操作 next('/login')强制跳转login
router.beforeEach((to, from, next) => {
    // 访问登录页，放行
    if (to.path === '/login') return next()
    // 获取token
    const tokenStr = window.sessionStorage.getItem('token')
    // 没有token, 强制跳转到登录页
    if (!tokenStr) return next('/login')
    next()
})

export default router
